<section class="product-image">
    <div class="product-image-container">
        <div class="image-tab">
            @if (asset) {
            <button
                class="image-button"
                (focus)="handleFocus()"
                (keypress.enter)="handleZoomModal(true)"
                (click)="handleZoomModal(true)"
                [attr.aria-haspopup]="'dialog'">
                <picture>
                    <source
                        [media]="'all'"
                        [attr.srcset]="
                            asset.url
                                | productImageSeoUrl
                                    : {
                                          slug: product.slug,
                                          imageSize: this.size,
                                          srcSet: true,
                                          templateType: product.templateType
                                      }
                        " />
                    <img
                        i18n-alt="@@hermes-product-page-translations.zoom-image"
                        alt="zoom image, {{ productTitle }}"
                        hZoomCursor
                        class="main-product-image"
                        [attr.src]="
                            asset.url
                                | productImageSeoUrl
                                    : {
                                          slug: product.slug,
                                          imageSize: this.size,
                                          srcSet: true,
                                          templateType: product.templateType
                                      }
                        " />
                </picture>
            </button>
            }
        </div>
    </div>
</section>
